module.exports = __webpack_public_path__ + "img/3.2301a257.png";